import * as Schema from "effect/Schema";

const PublicUrl = Schema.String.check(
  Schema.makeFilter((value) => {
    try {
      const url = new URL(value);
      return (
        ["https:", "http:"].includes(url.protocol) &&
        !url.username &&
        !url.password
      );
    } catch {
      return false;
    }
  }),
);
const Timestamp = Schema.String.check(
  Schema.makeFilter((value) => Number.isFinite(Date.parse(value))),
);

export const RegimePublication = Schema.Struct({
  id: Schema.String,
  title: Schema.String,
  url: Schema.NullOr(PublicUrl),
  kind: Schema.String,
  format: Schema.String,
  why: Schema.NullOr(Schema.String),
  status: Schema.Literals([
    "indexed",
    "pending",
    "paused",
    "failed",
    "discovered",
    "blocked",
    "restricted",
    "unverified",
  ]),
  chunks: Schema.Number.check(Schema.isInt(), Schema.isGreaterThanOrEqualTo(0)),
  lastCheckedAt: Schema.NullOr(Timestamp),
  indexedAt: Schema.NullOr(Timestamp),
  version: Schema.NullOr(Schema.String),
});
export type RegimePublication = typeof RegimePublication.Type;

export const RegimePublications = Schema.Struct({
  regimeId: Schema.String,
  publications: Schema.Array(RegimePublication),
  discovery: Schema.Struct({
    status: Schema.Literals(["not_run", "mapped", "partial", "blocked"]),
    lastCompletedAt: Schema.NullOr(Timestamp),
    enabled: Schema.Boolean,
    cron: Schema.NullOr(Schema.String),
    timezone: Schema.NullOr(Schema.String),
    nextRunAt: Schema.NullOr(Timestamp),
    gaps: Schema.Array(Schema.String),
  }),
});
export type RegimePublications = typeof RegimePublications.Type;
